module.exports = __webpack_public_path__ + "img/irrigation-control-4.42ef26e0.jpg";